import React, { FC } from 'react';

import { Box, useMediaQuery } from '@rbilabs/components-library';

import { StickyFooter } from 'components/sticky-footer/sticky-footer';
import { MediaQuery } from 'hooks/use-media-query';

import { StyledProductCtaWrapper } from './product-cta.styled';
import { IProductCtaWrapperProps } from './types';

// Wrapper for the CTA buttons depending on the device
export const ProductCtaWrapper: FC<IProductCtaWrapperProps> = ({
  button,
  incrementor,
  hideShadow,
}) => {
  const isDesktop = useMediaQuery(MediaQuery.Desktop);

  if (isDesktop) {
    return (
      <StyledProductCtaWrapper $hideShadow={hideShadow}>
        {incrementor}
        <Box width="100%" justify="center">
          {button}
        </Box>
      </StyledProductCtaWrapper>
    );
  }

  return (
    <StickyFooter
      boxProps={{ padding: '16px' }}
      elements={[{ element: incrementor }, { element: button }]}
    />
  );
};
